import script from "./ow-acc-cash-transactions-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-acc-cash-transactions-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-acc-cash-transactions-form.vue?vue&type=style&index=0&id=45587196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45587196"]])

export default __exports__